export default __webpack_public_path__ + "static/media/cl.fe01e70a.svg";